var EHDI = EHDI || Object.create(null);
var WTE = WTE || Object.create(null);


WTE.AnimalMap = Object.create(null);
WTE.AnimalMap.init = Function()
{
    WTE.AnimalMap['specieslist'] = specieslist =           ['lamb', 'goat', 'donkey', 'deer', 'ram', 'gazelle'];
    WTE.AnimalMap['bigspecieslist'] = bigspecieslist =     ['elephant', 'rhino', 'horse', 'giraffe'];
    WTE.AnimalMap['prowlspecieslist'] = prowlspecieslist = ['lion', 'tiger', 'bear'];
    WTE.AnimalMap['bushspecieslist'] = bushspecieslist =   ['sloth', 'monkey'];

    initializeAnimal = function(species, type)
    {
        var cage;
        var entry;
        var idle;
        var exit;
        var selected;
        var x = 0;
        var y = 0;

        switch(type)
        {
            case 'normal':
                cage=[2,3,4,5];                
            // cage=[0,1,2,3,4,5];                
                entry = 1;
                idle = 0;
                exit = 1;
                selected = 2;
                break;
            case 'big':
                cage=[6,7];                
                entry = 1;
                idle = 0;
                exit = 1;
                selected = 2;
                break;
            case 'prowl':
                cage=[4,5];                
                entry = 0;
                idle = 1;
                exit = 2;
                selected = 3;
                break;
            case 'bush':
                cage=[8,9];               
                entry = 0;
                idle = 1;
                exit = 2;
                selected = 3;
                break;
        }

        switch(species)
        {
            case 'lamb':
                x = 35;
                cage=[2,3,4,5];      
                break;
            case 'elephant':
                x = -100;
                break;
            case 'rhino':
                x = -70;
                break;
            case 'giraffe':
                x = -70;
                break;
            case 'horse':
                x = -20;
                break;
            case 'bear':
                x = -50;
                y = -100;
              break;
            case 'lion':
                x = -50;
                y = -100;
               break;
            case 'tiger':
                x = -50;
                y = -100;
                break;

        }

        return{
            classification: type,
            validCage: cage,
            entryIndex: entry,
            idleIndex: idle,
            exitIndex: exit,
            selectedIndex:selected,
            xOffset: x,
            yOffset: y
        };

    }

    for(var i = 0, l = specieslist.length; i<l; i++)
        {
            var species = specieslist[i];
            WTE.AnimalMap[species] = initializeAnimal(species, 'normal');
        }
    
    for(var i = 0, l = bigspecieslist.length; i<l; i++)
        {
            var species = bigspecieslist[i];
            WTE.AnimalMap[species] = initializeAnimal(species, 'big');
        }

    for(var i = 0, l = prowlspecieslist.length; i<l; i++)
        {
            var species = prowlspecieslist[i];
            WTE.AnimalMap[species] = initializeAnimal(species, 'prowl');
        }

    for(var i = 0, l = bushspecieslist.length; i<l; i++)
        {
            var species = bushspecieslist[i];
            WTE.AnimalMap[species] = initializeAnimal(species, 'bush');
        }
}
WTE.AnimalMap.init();


// WTE.AnimalMap['lamb'] = {classification: 'normal', entryIndex: 1, idleIndex: 0, exitIndex: 1, xOffset:25, yOffset:0, validCage:[0,1,2,3,4,5]};
// WTE.AnimalMap['goat'] = {classification: 'normal', entryIndex: 1, idleIndex: 0, exitIndex: 1, xOffset:0, yOffset:0, validCage:[0,1,2,3,4,5]};
// WTE.AnimalMap['donkey'] = {classification: 'normal', entryIndex: 1, idleIndex: 0, exitIndex: 1, xOffset:0, yOffset:0, validCage:[0,1,2,3,4,5]};
// WTE.AnimalMap['deer'] = {classification: 'normal', entryIndex: 1, idleIndex: 0, exitIndex: 1, xOffset:0, yOffset:0, validCage:[0,1,2,3,4,5]};
// WTE.AnimalMap['ram'] = {classification: 'normal', entryIndex: 1, idleIndex: 0, exitIndex: 1, xOffset:0, yOffset:0, validCage:[0,1,2,3,4,5]};
// WTE.AnimalMap['gazelle'] = {classification: 'normal', entryIndex: 1, idleIndex: 0, exitIndex: 1, xOffset:0, yOffset:0, validCage:[0,1,2,3,4,5]};

// WTE.AnimalMap['elephant'] = {classification: 'big', entryIndex: 1, idleIndex: 0, exitIndex: 1, xOffset:-100, yOffset:0, validCage:[6,7]};
// WTE.AnimalMap['rhino'] = {classification: 'big', entryIndex: 1, idleIndex: 0, exitIndex: 1, xOffset:-70, yOffset:0, validCage:[6,7]};
// WTE.AnimalMap['giraffe'] = {classification: 'big', entryIndex: 1, idleIndex: 0, exitIndex: 1, xOffset:-70, yOffset:0, validCage:[6,7]};
// WTE.AnimalMap['horse'] = {classification: 'big', entryIndex: 1, idleIndex: 0, exitIndex: 1, xOffset:-20, yOffset:0, validCage:[6,7]};

// WTE.AnimalMap['bear'] = {classification: 'prowl', entryIndex: 0, idleIndex: 1, exitIndex: 2, xOffset:-30, yOffset:-50, validCage:[4,5]};
// WTE.AnimalMap['lion'] = {classification: 'prowl', entryIndex: 0, idleIndex: 1, exitIndex: 2, xOffset:-30, yOffset:-50, validCage:[4,5]};
// WTE.AnimalMap['tiger'] = {classification: 'prowl', entryIndex: 0, idleIndex: 1, exitIndex: 2, xOffset:-30, yOffset:-50, validCage:[4,5]};

// WTE.AnimalMap['sloth'] = {classification: 'bush', entryIndex: 0, idleIndex: 1, exitIndex: 2, xOffset:0, yOffset:0, validCage:[]};
// WTE.AnimalMap['monkey'] = {classification: 'bush', entryIndex: 0, idleIndex: 1, exitIndex: 2, xOffset:0, yOffset:0, validCage:[]};
